import { render, staticRenderFns } from "./KeyFeatures.vue?vue&type=template&id=54944a86&scoped=true&lang=pug&"
import script from "./KeyFeatures.vue?vue&type=script&lang=js&"
export * from "./KeyFeatures.vue?vue&type=script&lang=js&"
import style0 from "./KeyFeatures.vue?vue&type=style&index=0&id=54944a86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54944a86",
  null
  
)

export default component.exports